import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Spin } from "antd";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { post, postFormData } from "../../../helpers/api_helper";
import { SVGICON } from "../../../constant/theme";
import CustomInput from "../../../CustomControls/CustomInput";
import {
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_DDLGetInwardsNoByCustomerID,
  POST_GetCustomerDDLList,
  POST_GetUploadScanCopiesGetDetailByInwardID,
  POST_GetUploadScanCopyAdditionalDocumentsDetailByID,
  POST_UploadScanCopiesSaveUpdate,
} from "../../../helpers/url_helper";

const AddUploadScanCopy = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [customerOptionList, setCustomerList] = useState([]);
  const [inwardNoOptionList, setInwardNoList] = useState([]);
  const [inwardMaterialID, setInwardMaterialID] = useState("");

  const [showUploadAdditionalDocModal, setShowUploadAdditionalDocModal] =
    useState(false);

  //const [uploadScanCopyFilePath, setUploadScanCopyFilePath] = useState("");
  //const [tCNumber, setTCNumber] = useState("");
  //const [addUploadScanCopyModal, setAddUploadScanCopyModal] = useState(false);

  const validationSchema = Yup.object().shape({
    CustomerIDEncrypted: Yup.string().required(
      "Customer Name is required field"
    ),
    InwardIDEncrypt: Yup.string().required("Inward No is required field"),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      InwardIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      CustomerIDEncrypted: "",
      InwardNo: "",
      ListOfInwardMaterialsDetails: [],
      ListOfUploadAdditionalDocFile: [],
      ListOfUploadAdditionalDocFileSubList: [],
      AddEditFlag: PrimaryIdParam ? 1 : 0,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      CustomerIDEncrypted,
      InwardIDEncrypt,
      ListOfInwardMaterialsDetails,
      ListOfUploadAdditionalDocFile,
      ListOfUploadAdditionalDocFileSubList,
      InwardNo,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let formData = new FormData();

    formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );

    Promise.all(
      values?.ListOfInwardMaterialsDetails?.map((x, i) => {
        formData.append(
          `ListOfScanCopy[${i}].UploadScanCopyIDEncrypted`,
          x.UploadScanCopyIDEncrypt
        );
        formData.append(
          `ListOfScanCopy[${i}].InwardMaterialIDEncrypted`,
          x.InwardMaterialIDEncrypt
        );
        formData.append(
          `ListOfScanCopy[${i}].ScanCopyFilePathFile`,
          x.ScanCopyFilePathFile
        );
        formData.append(
          `ListOfScanCopy[${i}].ScanCopyFilePath`,
          x.ScanCopyFilePath
        );
        formData.append(`ListOfScanCopy[${i}].IsDeleted`, x.IsDeleted);
      })
    );

    Promise.all(
      values?.ListOfUploadAdditionalDocFile?.map((x, i) => {
        formData.append(
          `ListOfAdditionalDocuments[${i}].UploadScanCopyAdditionalDocumentIDEncrypted`,
          x.UploadScanCopyAdditionalDocumentIDEncrypted
        );
        formData.append(
          `ListOfAdditionalDocuments[${i}].UploadScanCopyIDEncrypted`,
          x.UploadScanCopyIDEncrypted
        );
        formData.append(
          `ListOfAdditionalDocuments[${i}].InwardMaterialIDEncrypted`,
          x.InwardMaterialIDEncrypted
        );
        formData.append(
          `ListOfAdditionalDocuments[${i}].AdditionalDocumentFilePathFile`,
          x.AdditionalDocumentFilePathFile
        );
        formData.append(
          `ListOfAdditionalDocuments[${i}].AdditionalDocumentFilePath`,
          x.UploadAdditionalDocFilePath
        );
        formData.append(
          `ListOfAdditionalDocuments[${i}].IsDeleted`,
          x.IsDeleted
        );
      })
    );

    postFormData(POST_UploadScanCopiesSaveUpdate, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            // navigate("/upload-scan-copy-list");
            navigate(-1);
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getCustomerDDL();
  }, []);

  useEffect(() => {
    if (InwardIDEncrypt) {
      getUploadScanCopiesDetailByID(InwardIDEncrypt);
    }
  }, [InwardIDEncrypt]);

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getInwardNoDDL(CustomerIDEncrypted);
    }
  }, [CustomerIDEncrypted]);

  const getUploadScanCopiesDetailByID = async (id) => {
    setIsLoading(true);
    await post(POST_GetUploadScanCopiesGetDetailByInwardID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardIDEncrypted: id,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "CustomerIDEncrypted",
            response?.CustomerIDEncrypted
          );
          formik.setFieldValue("InwardIDEncrypt", response?.InwardIDEncrypted);
          formik.setFieldValue("InwardNo", response?.InwardNo);

          formik.setFieldValue(
            "ListOfInwardMaterialsDetails",
            response?.List?.map((x) => {
              return {
                ...x,
                UploadScanCopyIDEncrypt: x?.UploadScanCopyIDEncrypted,
                InwardMaterialIDEncrypt: x?.InwardMaterialIDEncrypted,
                TCNo: x?.TCNo,
                ScanCopyFilePath: x?.ScanCopyFilePath,
                ScanCopyFilePathFile: "",
                IsDeleted: false,
                viewScanCopyFilePathFile: "",
              };
            })
          );

          if (
            response?.CustomerIDEncrypted &&
            inwardNoOptionList?.length == 0
          ) {
            getInwardNoDDL(response?.CustomerIDEncrypted);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: -1, // -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerList(
            response?.CustomerDDLList?.map((item) => ({
              label: item.CustomerName,
              value: item.CustomerIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getInwardNoDDL = async (CustomerID) => {
    setIsLoading(true);
    await post(POST_DDLGetInwardsNoByCustomerID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CustomerIDEncrypted: CustomerID,
      IsMaterialReturnable: 2,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setInwardNoList(
            response?.List?.map((item) => ({
              label: item.InwardNo,
              value: item.InwardIDEncrypted,
            }))
          );

          if (response?.List?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              "InwardIDEncrypt",
              response?.List[0].InwardIDEncrypted
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeCustomer = (e) => {
    formik.setFieldValue("CustomerIDEncrypted", e?.value ?? "");
    formik.setFieldValue("ListOfInwardMaterialsDetails", []);
    formik.setFieldValue("InwardIDEncrypt", "");
    if (e?.value) {
      // getInwardNoDDL(e?.value);
    } else {
      // formik.setFieldValue("ListOfInwardMaterialsDetails", []);
      // formik.setFieldValue("InwardIDEncrypt", "");
      getInwardNoDDL("");
    }
  };

  const handleChangeInwardNo = (e) => {
    formik.setFieldValue("InwardIDEncrypt", e?.value ?? "");
    if (e?.value) {
      // getUploadScanCopiesDetailByID(e?.value);
    } else {
      formik.setFieldValue("ListOfInwardMaterialsDetails", []);
      formik.setFieldValue("InwardIDEncrypt", "");
    }
  };

  const addUploadAdditionalDoc = async (ID) => {
    if (ID) {
      setIsLoading(true);
      await post(POST_GetUploadScanCopyAdditionalDocumentsDetailByID, {
        UploadScanCopyIDEncrypted: ID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            let listUPC = response?.List?.map((x, indx) => ({
              UploadScanCopyAdditionalDocumentIDEncrypted:
                x?.UploadScanCopyAdditionalDocumentIDEncrypted,
              UploadScanCopyIDEncrypted: x?.UploadScanCopyIDEncrypted,
              InwardMaterialIDEncrypted: x?.InwardMaterialIDEncrypted,
              AdditionalDocumentFilePathFile: "",
              viewUploadAdditionalDocFile: "",
              AdditionalDocumentFilePath: x?.AdditionalDocumentFileName,
              // AdditionalDocumentFilePath: x?.AdditionalDocumentFilePath
              //   ? (x?.AdditionalDocumentFilePath?.split("/"))[
              //       x?.AdditionalDocumentFilePath?.split("/").length - 1
              //     ]
              //   : "",
              UploadAdditionalDocFilePath: x?.AdditionalDocumentFilePath,

              IsDeleted: false,
            }));

            formik.setFieldValue("ListOfUploadAdditionalDocFile", [
              ...listUPC,
              ...ListOfUploadAdditionalDocFileSubList,
            ]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }

    setShowUploadAdditionalDocModal(true);
  };

  const deleteUploadAdditionalDoc = (i) => {
    if (
      ListOfUploadAdditionalDocFile[i]
        ?.UploadScanCopyAdditionalDocumentIDEncrypted
    ) {
      formik.setFieldValue(
        `ListOfUploadAdditionalDocFile[${i}].IsDeleted`,
        true
      );
    } else {
      formik.setFieldValue(
        "ListOfUploadAdditionalDocFile",
        ListOfUploadAdditionalDocFile?.filter((x, ix) => ix != i)
      );
    }
  };

  const uploadAdditionalDocChange = (e, ID, type) => {
    setInwardMaterialID(ID);

    if (e.target.files[0]) {
      const file = e.target.files[0];

      // var pattern = /^application\/(pdf|doc|docx)$/i;
      // if (
      //   !file.type.match("pdf") &&
      //   !file.type.match("doc") &&
      //   !file.type.match("docx")
      // ) {
      //   warningMessage("Select valid file!");
      // } else {
      if (type == 1) {
        formik.setFieldValue("ListOfUploadAdditionalDocFileSubList", [
          ...ListOfUploadAdditionalDocFileSubList,
          {
            UploadScanCopyAdditionalDocumentIDEncrypted: "",
            InwardMaterialIDEncrypted: ID,
            UploadScanCopyIDEncrypted: "",
            AdditionalDocumentFilePathFile: file,
            viewUploadAdditionalDocFile: URL.createObjectURL(file),
            AdditionalDocumentFilePath: file?.name,
            UploadAdditionalDocFilePath: "",
            AdditionalDocumentFileName: file?.name,
            IsDeleted: false,
          },
        ]);
      } else if (type == 2) {
        formik.setFieldValue("ListOfUploadAdditionalDocFileSubList", [
          ...ListOfUploadAdditionalDocFileSubList,
          {
            UploadScanCopyAdditionalDocumentIDEncrypted: "",
            InwardMaterialIDEncrypted: ID,
            UploadScanCopyIDEncrypted: "",
            AdditionalDocumentFilePathFile: file,
            viewUploadAdditionalDocFile: URL.createObjectURL(file),
            AdditionalDocumentFilePath: file?.name,
            UploadAdditionalDocFilePath: "",
            AdditionalDocumentFileName: file?.name,
            IsDeleted: false,
          },
        ]);
        formik.setFieldValue("ListOfUploadAdditionalDocFile", [
          ...ListOfUploadAdditionalDocFile,
          {
            UploadScanCopyAdditionalDocumentIDEncrypted: "",
            InwardMaterialIDEncrypted: ID,
            UploadScanCopyIDEncrypted: "",
            AdditionalDocumentFilePathFile: file,
            viewUploadAdditionalDocFile: URL.createObjectURL(file),
            AdditionalDocumentFilePath: file?.name,
            UploadAdditionalDocFilePath: "",
            AdditionalDocumentFileName: file?.name,
            IsDeleted: false,
          },
        ]);
      }
      // }
    }
  };

  const uploadUploadScanCopyFile = (e, indx) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /(.png|.gif|.jpeg|.jpg|pdf)$/;

      if (!file.type.match(pattern)) {
        warningMessage("Select valid file!");
      } else {
        formik.setFieldValue(
          `ListOfInwardMaterialsDetails[${indx}].ScanCopyFilePathFile`,
          file
        );
        formik.setFieldValue(
          `ListOfInwardMaterialsDetails[${indx}].viewScanCopyFilePathFile`,
          URL.createObjectURL(file)
        );

        formik.setFieldValue(
          `ListOfInwardMaterialsDetails[${indx}].IsDeleted`,
          false
        );
      }
    }
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {/* {PrimaryIdParam ? "Edit" : "Add"} */}
              Upload Scan Copy
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={4}>
                    <Field
                      label="Customer Name"
                      name="CustomerIDEncrypted"
                      placeholder={"Select Customer Name"}
                      component={CustomSelect}
                      options={customerOptionList}
                      required
                      onChange={handleChangeCustomer}
                      autoFocus
                      isDisabled={PrimaryIdParam ? true : false}
                    />
                  </Col>
                  <Col lg={4}>
                    {PrimaryIdParam ? (
                      <Field
                        label="Inward No"
                        name="InwardNo"
                        component={CustomInput}
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Inward No"
                        name="InwardIDEncrypt"
                        placeholder={"Select Inward No"}
                        component={CustomSelect}
                        options={inwardNoOptionList}
                        onChange={handleChangeInwardNo}
                        required
                      />
                    )}
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <div className="d-flex justify-content-between mb-0">
                    <div className="d-flex mb-0">
                      <label>TC Details</label>
                    </div>
                  </div>

                  <Col lg={12}>
                    <div className="row">
                      <div className="table-responsive active-projects style-1 shorting">
                        <div
                          id="TestDetail-tbl_wrapper"
                          className="dataTables_wrapper table-responsive no-footer"
                          style={{
                            maxHeight: "450px",
                            overflow: "auto",
                          }}
                        >
                          <table
                            id="TestDetail-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                <th width="5%">Sr No.</th>
                                <th width="25%">TC No</th>
                                <th width="35%">Scan Copy file</th>
                                <th
                                  width="35%"
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  Additional Documents
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ListOfInwardMaterialsDetails?.length > 0 ? (
                                ListOfInwardMaterialsDetails?.map(
                                  (item, indx) => (
                                    <>
                                      <tr key={indx}>
                                        <td>{indx + 1}</td>
                                        <td>
                                          {item.TCNo}{" "}
                                          {item?.IsHold == true && (
                                            <>
                                              <b>[Hold]</b>
                                              <OverlayTrigger
                                                trigger={["hover", "focus"]}
                                                key={indx}
                                                responsive={true}
                                                overlay={
                                                  <Tooltip className="toltip-popover">
                                                    <strong className="p-1">
                                                      <label>Hold:</label>{" "}
                                                      {item?.HoldReason}
                                                    </strong>
                                                  </Tooltip>
                                                }
                                              >
                                                <span>
                                                  <i
                                                    className="fa fa-info-circle ms-2"
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "#9698ab",
                                                    }}
                                                  ></i>
                                                </span>
                                              </OverlayTrigger>
                                            </>
                                          )}
                                        </td>
                                        <td style={{ minWidth: "250px" }}>
                                          <div className="input-group">
                                            {item.ScanCopyFilePath ? (
                                              <div
                                                className="input-group-text"
                                                title="Download File"
                                                style={{
                                                  borderRadius:
                                                    "0.3rem 0 0 0.3rem",
                                                }}
                                              >
                                                <Link
                                                  to="#"
                                                  title="Download Scan Copy"
                                                  className="fs-14"
                                                  onClick={() => {
                                                    if (item?.IsHold == false) {
                                                      window.open(
                                                        item.ScanCopyFilePath,
                                                        "_blank"
                                                      );
                                                    }
                                                  }}
                                                  disabled={item?.IsHold}
                                                >
                                                  <i className="fa fa-download"></i>{" "}
                                                </Link>
                                              </div>
                                            ) : item?.viewScanCopyFilePathFile ? (
                                              <div
                                                className="input-group-text"
                                                title="View File"
                                                style={{
                                                  borderRadius:
                                                    "0.3rem 0 0 0.3rem",
                                                }}
                                              >
                                                <Link
                                                  to="#"
                                                  // className="icon-box icon-box-md bg-primary-light me-1"
                                                  className="icon-box icon-box-md me-1"
                                                  title="View"
                                                  onClick={() => {
                                                    window.open(
                                                      item.viewScanCopyFilePathFile
                                                        ? item.viewScanCopyFilePathFile
                                                        : ""
                                                    );
                                                  }}
                                                >
                                                  <i className="fa fa-eye" />
                                                </Link>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            <span className="form-control form-control-sm p-1 ps-2">
                                              <Link
                                                to="#"
                                                className="text-primary"
                                              >
                                                Upload Scan Copy
                                              </Link>
                                            </span>
                                            <div
                                              className="input-group-text"
                                              title="Choose File"
                                              style={{
                                                borderRadius:
                                                  "0 0.3rem 0.3rem 0",
                                              }}
                                            >
                                              <div className="open-file">
                                                <input
                                                  type="file"
                                                  id={`UploadScanCopyFilePath_${indx}`}
                                                  accept="image/png, image/gif, image/jpeg,application/pdf"
                                                  onChange={(e) => {
                                                    if (item?.IsHold == false) {
                                                      uploadUploadScanCopyFile(
                                                        e,
                                                        indx
                                                      );
                                                      setInwardMaterialID(
                                                        item.InwardMaterialIDEncrypt
                                                      );
                                                    }
                                                  }}
                                                  disabled={item?.IsHold}
                                                />
                                                <label
                                                  htmlFor={`UploadScanCopyFilePath_${indx}`}
                                                  name=""
                                                ></label>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "left",
                                            minWidth: "250px",
                                          }}
                                        >
                                          <div className="input-group">
                                            <span className="form-control form-control-sm p-1 ps-2">
                                              <Link
                                                to="#"
                                                className="text-primary"
                                                onClick={() => {
                                                  if (item?.IsHold == false) {
                                                    setInwardMaterialID(
                                                      item.InwardMaterialIDEncrypt
                                                    );
                                                    addUploadAdditionalDoc(
                                                      item.UploadScanCopyIDEncrypted
                                                    );
                                                  }
                                                }}
                                                disabled={item?.IsHold}
                                              >
                                                Upload Additional Doc
                                              </Link>
                                            </span>
                                            <div
                                              className="input-group-text"
                                              title="Choose File"
                                              style={{
                                                borderRadius:
                                                  "0 0.375rem 0.375rem 0",
                                              }}
                                            >
                                              <div className="open-file">
                                                <input
                                                  type="file"
                                                  id={`UpAdditionalDocFile_${indx}`}
                                                  // accept=".doc,.docx,application/pdf"
                                                  onChange={(e) => {
                                                    if (item?.IsHold == false) {
                                                      setInwardMaterialID(
                                                        item.InwardMaterialIDEncrypt
                                                      );
                                                      uploadAdditionalDocChange(
                                                        e,
                                                        item.InwardMaterialIDEncrypt,
                                                        1
                                                      );
                                                    }
                                                  }}
                                                  disabled={item?.IsHold}
                                                />
                                                <label
                                                  htmlFor={`UpAdditionalDocFile_${indx}`}
                                                  name=""
                                                ></label>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan={5} style={{ textAlign: "left" }}>
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button
                  type="submit"
                  // className="btn btn-primary"

                  className="btn btn-primary btn-sm me-2"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  // className="btn btn-danger light"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showUploadAdditionalDocModal}
          onHide={setShowUploadAdditionalDocModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Upload Additional Doc</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowUploadAdditionalDocModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div style={{ float: "right", marginRight: "2rem" }}>
                    + Add
                    <div
                      className="open-file mt-2"
                      style={{ marginLeft: "2rem" }}
                    >
                      <input
                        type="file"
                        id="AdditionalDocFile"
                        // accept=".doc,.docx,application/pdf"
                        onChange={(e) => {
                          uploadAdditionalDocChange(e, inwardMaterialID, 2);
                        }}
                      />
                      <label htmlFor="AdditionalDocFile" name=""></label>
                    </div>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting">
                    <div
                      id="UploadAdditionalDoc-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="UploadAdditionalDoc-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              File
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfUploadAdditionalDocFile?.filter(
                            (x) => x.IsDeleted == false
                          )?.length > 0 ? (
                            ListOfUploadAdditionalDocFile?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display:
                                    item.IsDeleted == true
                                      ? "none"
                                      : item.InwardMaterialIDEncrypted ==
                                        inwardMaterialID
                                      ? ""
                                      : "none",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.UploadAdditionalDocFilePath
                                          ? item.UploadAdditionalDocFilePath
                                          : item.viewUploadAdditionalDocFile
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      //deleteUploadAdditionalDoc(indx);
                                      delete_RecordWithoutApi(
                                        deleteUploadAdditionalDoc,
                                        indx
                                      );
                                    }}
                                    // onClick={() => {
                                    //   deleteUploadAdditionalDoc(indx);
                                    // }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.AdditionalDocumentFilePath}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowUploadAdditionalDocModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default AddUploadScanCopy;
